import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CtaButton } from "./CtaButton";
export function MobileCtaBar() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > window.innerHeight * 0.8);
    onScroll();
    window.addEventListener("scroll", onScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return <AnimatePresence data-id="element-108" data-mp="15aejk5in1xh9">
      {visible && <motion.div initial={{
      y: "100%"
    }} animate={{
      y: 0
    }} exit={{
      y: "100%"
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-50 border-t border-moss bg-deep/95 px-4 pb-4 pt-3 backdrop-blur md:hidden" data-id="element-109" data-mp="15bha2cc1txwn">
          <div className="flex items-center gap-3" data-id="element-110" data-mp="hkto4n5at7r3">
            <div className="leading-tight" data-id="element-111" data-mp="mjoimmcmokr1">
              <p className="text-[10px] font-semibold tracking-wider text-white/60" data-id="element-112" data-mp="middoj7g56yc">2 LIVRES + 5 BONUS</p>
              <p className="font-display text-2xl font-bold text-gold" data-id="element-113" data-mp="3fbv2ys1loonm">29 €</p>
            </div>
            <CtaButton label="Voir l'offre" action="offer" size="md" className="flex-1" data-id="element-114" data-mp="3b8yondj3feph" />
          </div>
        </motion.div>}
    </AnimatePresence>;
}